<template>
  <div class="left-nav">
    <div class="vip-center">
      <span class="item-info">
        <!-- <i class="iconfont">&#xe60a;</i> -->
        <b>会员中心</b>
      </span>
    </div>
      <router-link
        v-if="!isAdmin"
        to="/dashbord/info"
        class="item-content"
        :class="{'item-title-bg': $route.name === 'dashbord/info'}"
      >
        <b class="item-title" >个人中心</b>
        <span class="item-title-icon" v-if="$route.name === 'dashbord/info'"></span>
      </router-link>

      <router-link
        to="/dashbord/group"
        class="item-content"
        :class="{'item-title-bg': $route.name === 'dashbord/group'}"
      >
        <b class="item-title" >我的小组</b>
        <span class="item-title-icon" v-if="$route.name === 'dashbord/group'"></span>
      </router-link>

      <router-link
        to="/dashbord/activity"
        class="item-content"
        :class="{'item-title-bg': $route.name === 'dashbord/activity'}"
      >
        <b class="item-title" >我的活动</b>
        <span class="item-title-icon" v-if="$route.name === 'dashbord/activity'"></span>
      </router-link>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      checkedId: 0
    }
  },
  computed: {
    ...mapGetters([
      'isAdmin'
    ])
  },
  methods: {
  }
}
</script>
<style scoped lang='sass'>
@import '../../style/bulma/app.sass'

.left-nav
  border-radius: 5px
  a.left-nav-item
    display: block
    padding: 15px 30px
    // border-bottom: 1px solid #d9d9d9
    color: #353535
    &:hover
      color: $primary3
    &.focus
      color: $primary3
    span.item-info
      position: relative
      width: 100%
      display: flex
      padding-left: 30px
      font-size: 18px
      color: #353535
      .iconfont
        margin-right: 5px
        font-size: 20px
.vip-center
  padding: 22px 0 22px 30px
  border-bottom: 1px solid #F7F5F6
  font-size: 20px
  font-family: PingFangSC-Medium, PingFang SC
  font-weight: 500
  color: #353535

.item-wrapper
  display: flex
  flex-direction: column

.item-content
  display: flex
  justify-content: space-between
  align-items: center
  height: 50px
  padding: 15px 30px
  cursor: pointer
  color: #353535

.item-title
  font-size: 17px
  font-weight: 400

.item-title-bg
  height: 50px
  background: #FBF7F1
  color: #D7B477
  & .item-title
    font-weight: 500

.item-title-icon
  width: 6px
  height: 6px
  border-top: 1px solid #D7B477
  border-right: 1px solid #D7B477
  transform: rotate(45deg)

</style>
